import React from 'react';
import * as PropTypes from 'prop-types';

import { FormGroup } from './style';
import { Input } from 'semantic-ui-react';

const InputForm = ({ input, label, help, placeholder, loading, required, meta: { touched, error, warning } }) => {
  return (
    <FormGroup>
      <label>{label} <span style={{ color: 'red', fontWeight: '700' }}>{required && '*'}</span></label>
      <Input
        {...input}
        placeholder={placeholder}
        error={Boolean(touched && (error || warning))}
        loading={loading}
      />
      {
        touched &&
        (
          (error && <output>{error}</output>) ||
          (warning && <output>{warning}</output>)
        )
      }
      {
        help &&
        <p className={'help_block'}>{help}</p>
      }
    </FormGroup>
  );
};

InputForm.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  loading: PropTypes.bool,
  required: PropTypes.bool
};

InputForm.defaultProps = {
  loading: false,
  required: false,
};

export default InputForm;